import React, { useEffect, useRef } from 'react';
import { Col, Container, Row } from 'shards-react';
import PageTitle from '../components/common/PageTitle';
import Notification from '../components/common/Notification';
import TextFiltering from '../components/common/ag-grid/TextFiltering';
import AddDeliveryLocation from '../components/manage-delivery-location/AddDeliveryLocation';
import GridDeliveryLocation from '../components/manage-delivery-location/GridDeliveryLocation';
import ModalEditDeliveryLocation from '../components/manage-delivery-location/ModalEditDeliveryLocation';
import { useTranslation } from 'react-i18next';
import useUserRoles from '../hooks/useUserRoles';
import { RootState, useDispatch, useSelector } from '../redux/store';
import { getDeliveryLocations, resetMessage } from '../redux/slices/deliveryLocation';
import { getSteelMakerOptions } from '../redux/slices/options';
import { getUsers } from '../redux/slices/user';
import type { AgGridReact as AgGridReactType } from 'ag-grid-react/lib/agGridReact';

const ManageDeliveryLocation = (): React.ReactElement => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { hasError, serverMessage } = useSelector((state: RootState) => state.deliveryLocation);
  const { isMaintenanceadmin } = useUserRoles();
  const gridRef = useRef<AgGridReactType>(null);

  // SIDE EFFECT
  // ================================================================================

  // 確認用
  // useEffect(() => {
  // }, []);

  useEffect(() => {
    dispatch(getSteelMakerOptions());
    dispatch(getUsers({}));
    dispatch(getDeliveryLocations());
  }, []);

  // EVENT HANDLER
  // ================================================================================

  /**
   * クローズボタンを押したとき
   */
  const dismiss = (): void => {
    dispatch(resetMessage());
  };

  // VIEW
  // ================================================================================

  return (
    <Container fluid className="main-content-container px-4">
      <Row id="pageTitle" noGutters className="page-header py-4">
        <PageTitle sm="4" title={t('deliveryLocation.manage')} subtitle="Manage Delivery Location" className="text-sm-left" />
      </Row>

      <Notification theme={hasError ? 'danger' : 'success'} isOpen={serverMessage !== undefined && serverMessage.length > 0} message={serverMessage} dismissCallback={dismiss} />

      <Row className="mb-4">
        <Col md="3" sm="6">
          <TextFiltering gridRef={gridRef} />
        </Col>
        <Col md="3" sm="6">
          {isMaintenanceadmin && <AddDeliveryLocation />}
        </Col>
      </Row>

      <GridDeliveryLocation ref={gridRef} />

      <ModalEditDeliveryLocation />
    </Container>
  );
};

export default ManageDeliveryLocation;
